/* eslint-disable complexity */
// Models
import Entity from '../models/entity';
import Timeline from '../models/timeline';
import PaymentModes from '../models/paymentModes';
import {
    getFlatEntities,
    createSurchargeOptions,
} from '../../../utils/helperMethods';

import {
    FETCH_ENTITY_SUCCESS,
    FETCH_ENTITY_ERROR,
    SHOW_MERCHANT_LOADER,
    HIDE_MERCHANT_LOADER,
    FETCH_FORM_DETAILS_SUCCESS,
    FETCH_FORM_DETAILS_ERROR,
    FETCH_FORM_IN_PROCESS_SUCCESS,
    FETCH_FORM_IN_PROCESS_ERROR,
    FETCH_ENTITY_LIST_MERCHANT_REQUEST,
    FETCH_ENTITY_LIST_MERCHANT_SUCCESS,
    FETCH_ENTITY_LIST_MERCHANT_SUCCESS_ADD_LIST,
    FETCH_ENTITY_LIST_MERCHANT_ERROR,
    FETCH_ENTITY_HIERARCHY_SUCCESS,
    FETCH_ENTITY_HIERARCHY_ERROR,
    SAVE_AND_CONTINUE_SUCCESS,
    SAVE_AND_CONTINUE_ERROR,
    SAVE_AND_CONTINUE_REQUEST,
    CREATE_ENTITY_REQUEST,
    CREATE_ENTITY_SUCCESS,
    CREATE_ENTITY_ERROR,
    FETCH_PAYMENT_MODES_SUCCESS,
    FETCH_PAYMENT_MODES_ERROR,
    FETCH_SURCHARGE_SLABS_SUCCESS,
    FETCH_SURCHARGE_SLABS_ERROR,
    FETCH_DEFAULT_ROUTING_SUCCESS,
    FETCH_DEFAULT_ROUTING_ERROR,
    SET_UNIQUE_IDENTIFIER_SUCCESS,
    SET_UNIQUE_IDENTIFIER_ERROR,
    FETCH_ENTITY_HIERARCHY_MLE_SUCCESS,
    FETCH_ENTITY_HIERARCHY_MLE_ERROR,
    FETCH_ENTITY_LIST_MERCHANT_MLE_SUCCESS,
    FETCH_ENTITY_LIST_MERCHANT_MLE_ERROR,
    RESET_SAVEDATA_SUCCESS_KEY,
    SUBMIT_FORM_SUCCESS,
    SUBMIT_FORM_ERROR,
    RETRY_FAILED_MERCHANT_FORM_SUCCESS,
    RETRY_FAILED_MERCHANT_FORM_ERROR,
    RESET_RETRY_FORM_STORE,
    SHOW_ENTITY_HIERARCHY_LOADER,
    HIDE_ENTITY_HIERARCHY_LOADER,
    SUBMIT_STEP_FORM_REQUEST,
    SUBMIT_STEP_FORM_SUCCESS,
    SUBMIT_STEP_FORM_ERROR,
    FETCH_BD_INPROGRESS_MERCHANT_SUCCESS,
    FETCH_BD_INPROGRESS_MERCHANT_ERROR,
    RESET_FORM_INPROCESS_DATA,
    ADD_HIERARCHY_DATA,
    REMOVE_HIERARCHY_DATA,
    SET_ENTITY_LIST_LOADING,
} from './merchantOnBoard.constants';

export const initialState = {
    tableData: [],
    pagination: {},
    error: {},
    timeline: {
        fields: [],
        error: {},
    },
    formInProcess: {},
    entityList: {},
    saveData: {
        isSuccess: false,
    },
    createEntity: {},
    paymentModes: {
        netbanking: [],
        creditCards: [],
        debitCards: [],
    },
    defaultRouting: [],
    surchargeOptions: {},
    uniqueIdentifier: {
        uniqueId: '',
        isInEditMode: false,
        error: {},
    },
    addRole: {},
    submitData: {
        isSuccess: false,
    },
    retryForm: {
        isSuccess: false,
    },
    hierarchyLoader: 0,
    listExecuting: 0,
    hierarchyData: {},
    merchantListLoading: false,
    mleListLoading: false,
    aggregatorListLoading: false,
    partnerListLoading: false,
};

// eslint-disable-next-line max-lines-per-function
export const merchantReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ENTITY_SUCCESS: {
            const createEntity = new Entity(action.payload);
            return { ...state, ...createEntity, error: {} };
        }
        case FETCH_ENTITY_ERROR:
            return { ...state, ...action.payload };
        case FETCH_FORM_DETAILS_SUCCESS: {
            const timeline = new Timeline(action.payload);
            return { ...state, timeline: { ...timeline, error: {} } };
        }
        case FETCH_FORM_DETAILS_ERROR: {
            return { ...state, timeline: { ...action.payload } };
        }
        case FETCH_FORM_IN_PROCESS_SUCCESS: {
            return {
                ...state,
                formInProcess: { ...action.payload, error: {} },
            };
        }
        case FETCH_FORM_IN_PROCESS_ERROR: {
            return {
                ...state,
                formInProcess: { ...action.payload },
            };
        }
        case FETCH_ENTITY_LIST_MERCHANT_REQUEST:
            return { ...state, listExecuting: state.listExecuting + 1 };
        case FETCH_ENTITY_LIST_MERCHANT_SUCCESS: {
            const entities = { ...state.entityList, ...action.payload };
            return {
                ...state,
                entityList: entities,
                listExecuting: state.listExecuting - 1,
            };
        }

        case FETCH_ENTITY_LIST_MERCHANT_SUCCESS_ADD_LIST: {
            // If deletePrevious is true, replace the existing list with the new one
            const updatedEntities = action.deletePrevious ? [
                ...action.payload[action.entityType]
            ] : [
                ...action.payload[action.entityType],
                ...state.entityList[action.entityType]
            ].reduce((acc, item) => {
                if (!acc.some(existing => existing.entityCode === item.entityCode)) {
                    acc.push(item);
                }
                return acc;
            }, []);

            const entities = {
                ...state.entityList,
                [action.entityType]: updatedEntities
            };

            return {
                ...state,
                entityList: entities,
                listExecuting: state.listExecuting - 1,
            };
        }
        case FETCH_ENTITY_LIST_MERCHANT_ERROR: {
            return {
                ...state,
                entityList: { ...action.payload },
                listExecuting: state.listExecuting - 1,
            };
        }
        case FETCH_ENTITY_HIERARCHY_SUCCESS: {
            const flatEntities = getFlatEntities(
                action.payload,
                action.entityType
            );
            const entities = { ...state.entityList, ...flatEntities };
            return { ...state, entityList: entities };
        }
        case FETCH_ENTITY_HIERARCHY_ERROR: {
            return { ...state, entityList: { ...action.payload } };
        }

        case FETCH_ENTITY_HIERARCHY_MLE_SUCCESS: {
            const flatEntities = getFlatEntities(
                action.payload,
                action.entityType
            );
            const entities = { ...state.addRole, ...flatEntities };
            return { ...state, addRole: entities };
        }

        case FETCH_ENTITY_HIERARCHY_MLE_ERROR: {
            return { ...state, addRole: { ...action.payload } };
        }

        case SAVE_AND_CONTINUE_REQUEST: {
            const saveData = { ...state.saveData, ...{ isSuccess: false } };
            return { ...state, saveData: { ...saveData } };
        }

        case SAVE_AND_CONTINUE_SUCCESS: {
            const saveData = {
                ...state.saveData,
                ...{ isSuccess: true, sectionType: action.sectionType },
                customisedReports:action.customisedReports
            };
            return {
                ...state,
                saveData: { ...saveData },
                formInProcess: { ...action.payload },
            };
        }

        case SAVE_AND_CONTINUE_ERROR: {
            const saveData = {
                ...state.saveData,
                ...{ isSuccess: false, ...action.payload },
            };
            return { ...state, saveData: { ...saveData } };
        }

        case CREATE_ENTITY_REQUEST: {
            const createEntity = {
                ...state.createEntity,
                ...{ isSuccess: false },
            };
            return { ...state, createEntity: { ...createEntity } };
        }

        case CREATE_ENTITY_SUCCESS: {
            const createEntity = {
                ...state.createEntity,
                ...{ isSuccess: true },
            };
            return { ...state, createEntity: { ...createEntity } };
        }

        case CREATE_ENTITY_ERROR: {
            const createEntity = {
                ...state.createEntity,
                ...{ isSuccess: false, ...action.payload },
            };
            return { ...state, createEntity: { ...createEntity } };
        }
        case FETCH_PAYMENT_MODES_SUCCESS:
            const paymentModes = new PaymentModes(action.payload.paymetModes);
            return { ...state, paymentModes: { ...paymentModes.payModes } };

        case FETCH_PAYMENT_MODES_ERROR:
            return { ...state, paymentModes: { ...action.payload } };

        case FETCH_SURCHARGE_SLABS_SUCCESS:
            const surchargeOptions = createSurchargeOptions(
                action.payload.basicSectionData.basicFees
            );
            return {
                ...state,
                surchargeOptions: {
                    ...surchargeOptions,
                    paymentOptionList: action.payload.paymentOptionList,
                    schemes: action.payload.basicSectionData.schemes,
                    cardCategoriesOptions:
                        action?.payload?.basicSectionData?.cardCategories || [],
                },
            };

        case FETCH_SURCHARGE_SLABS_ERROR:
            return {
                ...state,
                surchargeOptions: { ...action.payload },
            };

        case FETCH_DEFAULT_ROUTING_SUCCESS:
            return {
                ...state,
                defaultRouting: [...action.payload.pgRoutingResponseList],
            };

        case FETCH_DEFAULT_ROUTING_ERROR:
            return {
                ...state,
                defaultRouting: { ...action.payload },
            };

        case SET_UNIQUE_IDENTIFIER_SUCCESS:
            return {
                ...state,
                uniqueIdentifier: {
                    uniqueId: action.payload,
                    isInEditMode: action.isEditMode,
                },
            };

        case SET_UNIQUE_IDENTIFIER_ERROR:
            return {
                ...state,
                uniqueIdentifier: { ...action.payload },
            };

        case FETCH_ENTITY_LIST_MERCHANT_MLE_SUCCESS: {
            const entities = { ...state.addRole, ...action.payload };
            return { ...state, addRole: entities };
        }
        case FETCH_ENTITY_LIST_MERCHANT_MLE_ERROR: {
            return {
                ...state,
                addRole: { error: { ...action.payload } },
            };
        }
        case SUBMIT_FORM_SUCCESS: {
            const submitData = {
                ...state.submitData,
                ...{ isSuccess: true },
            };
            return {
                ...state,
                submitData: { ...submitData },
            };
        }
        case SUBMIT_FORM_ERROR: {
            const submitData = {
                ...state.submitData,
                ...{ isSuccess: false, ...action.payload },
            };
            return { ...state, submitData: { ...submitData } };
        }

        case RESET_SAVEDATA_SUCCESS_KEY: {
            return { ...state, saveData: {} };
        }

        case SHOW_MERCHANT_LOADER:
            return { ...state, isLoading: true };

        case HIDE_MERCHANT_LOADER:
            return { ...state, isLoading: false };
        case RETRY_FAILED_MERCHANT_FORM_SUCCESS: {
            return { ...state, retryForm: { isSuccess: true } };
        }
        case RETRY_FAILED_MERCHANT_FORM_ERROR:
            return { ...state, retryForm: { isSuccess: false } };
        case RESET_RETRY_FORM_STORE:
            return { ...state, retryForm: { isSuccess: false } };
        case SHOW_ENTITY_HIERARCHY_LOADER:
            return { ...state, hierarchyLoader: state.hierarchyLoader + 1 };
        case HIDE_ENTITY_HIERARCHY_LOADER:
            return { ...state, hierarchyLoader: state.hierarchyLoader - 1 };
        case SET_ENTITY_LIST_LOADING: {
                const { entityType, isLoading } = action.payload;
                return {
                    ...state,
                    [`${entityType}ListLoading`]: isLoading,
                };
            }
        case SUBMIT_STEP_FORM_REQUEST: {
            const saveData = { ...state.saveData, ...{ isSuccess: false } };
            return { ...state, saveData: { ...saveData } };
        }
        case SUBMIT_STEP_FORM_SUCCESS: {
            const saveData = {
                ...state.saveData,
                ...{ isSuccess: true, sectionType: action.sectionType },
            };
            return {
                ...state,
                saveData: { ...saveData },
                formInProcess: { ...action.payload },
            };
        }
        case SUBMIT_STEP_FORM_ERROR: {
            const saveData = {
                ...state.saveData,
                ...{ isSuccess: false, ...action.payload },
            };
            return { ...state, saveData: { ...saveData } };
        }
        case FETCH_BD_INPROGRESS_MERCHANT_ERROR:
            return { ...state, ...action.payload };
        case FETCH_BD_INPROGRESS_MERCHANT_SUCCESS:
            /* the 'forms' list and additional Entity properties. this will make sure to pick the form where it is left by the user */
            const formsList = action.payload.data.map(item => item.form);
            const formsPayload = { forms: formsList };
            const createEntity = new Entity(action.payload);
            return {
                ...state,
                ...createEntity,
                formInProcess: { ...formsPayload },
                error: {},
            };
        case RESET_FORM_INPROCESS_DATA: 
            return {
                ...state,
                formInProcess: initialState.formInProcess,
                uniqueIdentifier: initialState.uniqueIdentifier,
                entityList: initialState.entityList,
            }
        case ADD_HIERARCHY_DATA:
            return { ...state, hierarchyData: action.payload || {} };
        case REMOVE_HIERARCHY_DATA:
            return { ...state, hierarchyData: {} };
        default:
            return state;
    }
};
